import { cn } from '@neo/lib/utils'
import { Loader } from '@neo/primitives/loader'
import type { FC } from 'react'

interface SuspenseLoaderProps {
  text?: string
  variant?: 'default' | 'inline' | 'circle'
}

export const SuspenseLoader: FC<SuspenseLoaderProps> = ({ text, variant = 'default' }) => (
  <div
    className={cn(
      'grid place-items-center w-full h-full',
      variant === 'inline' && 'flex items-center',
    )}
  >
    <Loader text={text} variant={variant} />
  </div>
)
